import React, { useState } from 'react';
import {
    Box,
    Input,
    Table,
    Sheet,
    Typography,
    Chip,
    CircularProgress
} from '@mui/joy';
import axios from 'axios';
import domain from "../../../util/domain";

export default function SearchFeedback() {
    const [query, setQuery] = useState('');
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleSearch = async () => {
        if (!query.trim()) return;

        try {
            setLoading(true);
            const response = await axios.get(`${domain}/frontoffice/feedback/search`, {
                params: { query }
            });
            setResults(response.data);
        } catch (error) {
            console.error('Error searching feedback:', error);
        } finally {
            setLoading(false);
        }
    };

    const getRatingColor = (rating, type) => {
        if (type === 'response' || type === 'interaction') {
            if (rating >= 4) return 'success';
            if (rating >= 3) return 'warning';
            return 'danger';
        }
        return rating === 1 ? 'success' : 'neutral';
    };

    return (
        <Box>
            <Box sx={{ mb: 2 }}>
                <Input
                    placeholder="Search by student name or media type..."
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                    sx={{ width: '100%' }}
                />
            </Box>

            {loading ? (
                <CircularProgress />
            ) : (
                <Sheet variant="outlined" sx={{ borderRadius: 'md', overflow: 'auto' }}>
                    <Table stickyHeader hoverRow>
                        <thead>
                            <tr>
                                <th>Student Name</th>
                                <th>Response Rating</th>
                                <th>Counsellor Clarity</th>
                                <th>Needs Info</th>
                                <th>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {results.map(item => (
                                <tr key={item.id}>
                                    <td>
                                        <Typography level="body-sm">
                                            {item.student_name}
                                        </Typography>
                                    </td>
                                    <td>
                                        <Chip
                                            size="sm"
                                            variant="soft"
                                            color={getRatingColor(item.response_rating, 'response')}
                                        >
                                            {item.response_rating}/4
                                        </Chip>
                                    </td>
                                    <td>
                                        <Chip
                                            size="sm"
                                            variant="soft"
                                            color={getRatingColor(item.counsellor_clarity, 'clarity')}
                                        >
                                            {item.counsellor_clarity ? 'Yes' : 'No'}
                                        </Chip>
                                    </td>
                                    <td>
                                        <Chip
                                            size="sm"
                                            variant="soft"
                                            color={getRatingColor(item.needs_more_info, 'info')}
                                        >
                                            {item.needs_more_info ? 'Yes' : 'No'}
                                        </Chip>
                                    </td>
                                    <td>
                                        <Typography level="body-sm">
                                            {new Date(item.createdAt).toLocaleDateString()}
                                        </Typography>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                    {results.length === 0 && query && (
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                p: 3
                            }}
                        >
                            <Typography level="body-lg">
                                No results found for "{query}"
                            </Typography>
                        </Box>
                    )}
                </Sheet>
            )}
        </Box>
    );
} 